import { render, staticRenderFns } from "./image-gallery.vue?vue&type=template&id=4b41e4e8&scoped=true&"
import script from "./image-gallery.vue?vue&type=script&lang=js&"
export * from "./image-gallery.vue?vue&type=script&lang=js&"
import style0 from "./image-gallery.vue?vue&type=style&index=0&id=4b41e4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41e4e8",
  null
  
)

export default component.exports